import NewsTab from '../components/NewsTab';
import ScoresTelegramCard from './ScoresTelegramCard';

const ScoresNews = () => (
  <div className="pt-1" data-testid="scores-news-page">
    <ScoresTelegramCard />
    <div className="px-3 pt-2">
      <NewsTab />
    </div>
  </div>
);

export default ScoresNews;
